/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { DeliverObjectDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getDeliverObject = (signal?: AbortSignal) => {
  return customInstance<DeliverObjectDto[]>({
    url: `/deliver-object`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectInfiniteQueryKey = () => {
  return ["infinite", `/deliver-object`] as const;
};

export const getGetDeliverObjectQueryKey = () => {
  return [`/deliver-object`] as const;
};

export const getGetDeliverObjectInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObject>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDeliverObject>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeliverObjectInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObject>>
  > = ({ signal }) => getDeliverObject(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObject>>
>;
export type GetDeliverObjectInfiniteQueryError = void;

export function useGetDeliverObjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObject>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObject>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObject>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetDeliverObjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObject>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObject>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDeliverObject>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeliverObjectQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObject>>
  > = ({ signal }) => getDeliverObject(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObject>>
>;
export type GetDeliverObjectQueryError = void;

export function useGetDeliverObject<
  TData = Awaited<ReturnType<typeof getDeliverObject>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObject>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObject<
  TData = Awaited<ReturnType<typeof getDeliverObject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObject>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObject<
  TData = Awaited<ReturnType<typeof getDeliverObject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetDeliverObject<
  TData = Awaited<ReturnType<typeof getDeliverObject>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postDeliverObject = (
  deliverObjectDto: DeliverObjectDto,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDto>({
    url: `/deliver-object`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: deliverObjectDto,
    signal,
  });
};

export const getPostDeliverObjectMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDeliverObject>>,
    TError,
    { data: DeliverObjectDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDeliverObject>>,
  TError,
  { data: DeliverObjectDto },
  TContext
> => {
  const mutationKey = ["postDeliverObject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDeliverObject>>,
    { data: DeliverObjectDto }
  > = (props) => {
    const { data } = props ?? {};

    return postDeliverObject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDeliverObjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDeliverObject>>
>;
export type PostDeliverObjectMutationBody = DeliverObjectDto;
export type PostDeliverObjectMutationError = void;

/**
 * @summary Create
 */
export const usePostDeliverObject = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDeliverObject>>,
      TError,
      { data: DeliverObjectDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDeliverObject>>,
  TError,
  { data: DeliverObjectDto },
  TContext
> => {
  const mutationOptions = getPostDeliverObjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putDeliverObjectId = (
  id: number,
  deliverObjectDto: DeliverObjectDto,
) => {
  return customInstance<DeliverObjectDto>({
    url: `/deliver-object/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: deliverObjectDto,
  });
};

export const getPutDeliverObjectIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDeliverObjectId>>,
    TError,
    { id: number; data: DeliverObjectDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDeliverObjectId>>,
  TError,
  { id: number; data: DeliverObjectDto },
  TContext
> => {
  const mutationKey = ["putDeliverObjectId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDeliverObjectId>>,
    { id: number; data: DeliverObjectDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putDeliverObjectId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDeliverObjectIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDeliverObjectId>>
>;
export type PutDeliverObjectIdMutationBody = DeliverObjectDto;
export type PutDeliverObjectIdMutationError = void;

/**
 * @summary Update
 */
export const usePutDeliverObjectId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDeliverObjectId>>,
      TError,
      { id: number; data: DeliverObjectDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDeliverObjectId>>,
  TError,
  { id: number; data: DeliverObjectDto },
  TContext
> => {
  const mutationOptions = getPutDeliverObjectIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getDeliverObjectId = (id: number, signal?: AbortSignal) => {
  return customInstance<DeliverObjectDto>({
    url: `/deliver-object/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/deliver-object/${id}`] as const;
};

export const getGetDeliverObjectIdQueryKey = (id?: number) => {
  return [`/deliver-object/${id}`] as const;
};

export const getGetDeliverObjectIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeliverObjectIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectId>>
  > = ({ signal }) => getDeliverObjectId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectId>>
>;
export type GetDeliverObjectIdInfiniteQueryError = void;

export function useGetDeliverObjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetDeliverObjectIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeliverObjectIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectId>>
  > = ({ signal }) => getDeliverObjectId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectId>>
>;
export type GetDeliverObjectIdQueryError = void;

export function useGetDeliverObjectId<
  TData = Awaited<ReturnType<typeof getDeliverObjectId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectId<
  TData = Awaited<ReturnType<typeof getDeliverObjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectId<
  TData = Awaited<ReturnType<typeof getDeliverObjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetDeliverObjectId<
  TData = Awaited<ReturnType<typeof getDeliverObjectId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteDeliverObjectId = (id: number) => {
  return customInstance<boolean>({
    url: `/deliver-object/${id}`,
    method: "DELETE",
  });
};

export const getDeleteDeliverObjectIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeliverObjectId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDeliverObjectId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDeliverObjectId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDeliverObjectId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDeliverObjectId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDeliverObjectIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDeliverObjectId>>
>;

export type DeleteDeliverObjectIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteDeliverObjectId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDeliverObjectId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDeliverObjectId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteDeliverObjectIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Phase Id
 */
export const getDeliverObjectIdPhase = (id: number, signal?: AbortSignal) => {
  return customInstance<DeliverObjectDto[]>({
    url: `/deliver-object/${id}/phase`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectIdPhaseInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/deliver-object/${id}/phase`] as const;
};

export const getGetDeliverObjectIdPhaseQueryKey = (id?: number) => {
  return [`/deliver-object/${id}/phase`] as const;
};

export const getGetDeliverObjectIdPhaseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeliverObjectIdPhaseInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
  > = ({ signal }) => getDeliverObjectIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectIdPhaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
>;
export type GetDeliverObjectIdPhaseInfiniteQueryError = void;

export function useGetDeliverObjectIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectIdPhase>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetDeliverObjectIdPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDeliverObjectIdPhase>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectIdPhaseInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectIdPhaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeliverObjectIdPhaseQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
  > = ({ signal }) => getDeliverObjectIdPhase(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectIdPhaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
>;
export type GetDeliverObjectIdPhaseQueryError = void;

export function useGetDeliverObjectIdPhase<
  TData = Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdPhase<
  TData = Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectIdPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectIdPhase<
  TData = Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Phase Id
 */

export function useGetDeliverObjectIdPhase<
  TData = Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectIdPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectIdPhaseQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All By Milestone Id
 */
export const getDeliverObjectMilestoneIdMilestone = (
  milestoneId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDto[]>({
    url: `/deliver-object/${milestoneId}/milestone`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectMilestoneIdMilestoneInfiniteQueryKey = (
  milestoneId?: number,
) => {
  return ["infinite", `/deliver-object/${milestoneId}/milestone`] as const;
};

export const getGetDeliverObjectMilestoneIdMilestoneQueryKey = (
  milestoneId?: number,
) => {
  return [`/deliver-object/${milestoneId}/milestone`] as const;
};

export const getGetDeliverObjectMilestoneIdMilestoneInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  >,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectMilestoneIdMilestoneInfiniteQueryKey(milestoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  > = ({ signal }) => getDeliverObjectMilestoneIdMilestone(milestoneId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!milestoneId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectMilestoneIdMilestoneInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>>;
export type GetDeliverObjectMilestoneIdMilestoneInfiniteQueryError = void;

export function useGetDeliverObjectMilestoneIdMilestoneInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  >,
  TError = void,
>(
  milestoneId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectMilestoneIdMilestoneInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  >,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectMilestoneIdMilestoneInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  >,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Milestone Id
 */

export function useGetDeliverObjectMilestoneIdMilestoneInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  >,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectMilestoneIdMilestoneInfiniteQueryOptions(
      milestoneId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectMilestoneIdMilestoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectMilestoneIdMilestoneQueryKey(milestoneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
  > = ({ signal }) => getDeliverObjectMilestoneIdMilestone(milestoneId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!milestoneId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectMilestoneIdMilestoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
>;
export type GetDeliverObjectMilestoneIdMilestoneQueryError = void;

export function useGetDeliverObjectMilestoneIdMilestone<
  TData = Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
  TError = void,
>(
  milestoneId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectMilestoneIdMilestone<
  TData = Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectMilestoneIdMilestone<
  TData = Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Milestone Id
 */

export function useGetDeliverObjectMilestoneIdMilestone<
  TData = Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
  TError = void,
>(
  milestoneId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectMilestoneIdMilestone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectMilestoneIdMilestoneQueryOptions(
    milestoneId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Unassigned For Project
 */
export const getDeliverObjectProjectIdUnassigned = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDto>({
    url: `/deliver-object/${projectId}/unassigned`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectProjectIdUnassignedInfiniteQueryKey = (
  projectId?: number,
) => {
  return ["infinite", `/deliver-object/${projectId}/unassigned`] as const;
};

export const getGetDeliverObjectProjectIdUnassignedQueryKey = (
  projectId?: number,
) => {
  return [`/deliver-object/${projectId}/unassigned`] as const;
};

export const getGetDeliverObjectProjectIdUnassignedInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectProjectIdUnassignedInfiniteQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  > = ({ signal }) => getDeliverObjectProjectIdUnassigned(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectProjectIdUnassignedInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>>;
export type GetDeliverObjectProjectIdUnassignedInfiniteQueryError = void;

export function useGetDeliverObjectProjectIdUnassignedInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectProjectIdUnassignedInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectProjectIdUnassignedInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Unassigned For Project
 */

export function useGetDeliverObjectProjectIdUnassignedInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectProjectIdUnassignedInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectProjectIdUnassignedQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectProjectIdUnassignedQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
  > = ({ signal }) => getDeliverObjectProjectIdUnassigned(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectProjectIdUnassignedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
>;
export type GetDeliverObjectProjectIdUnassignedQueryError = void;

export function useGetDeliverObjectProjectIdUnassigned<
  TData = Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectProjectIdUnassigned<
  TData = Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectProjectIdUnassigned<
  TData = Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Unassigned For Project
 */

export function useGetDeliverObjectProjectIdUnassigned<
  TData = Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectProjectIdUnassigned>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectProjectIdUnassignedQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All By Release Id
 */
export const getDeliverObjectReleaseIdRelease = (
  releaseId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDto[]>({
    url: `/deliver-object/${releaseId}/release`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectReleaseIdReleaseInfiniteQueryKey = (
  releaseId?: number,
) => {
  return ["infinite", `/deliver-object/${releaseId}/release`] as const;
};

export const getGetDeliverObjectReleaseIdReleaseQueryKey = (
  releaseId?: number,
) => {
  return [`/deliver-object/${releaseId}/release`] as const;
};

export const getGetDeliverObjectReleaseIdReleaseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  >,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectReleaseIdReleaseInfiniteQueryKey(releaseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  > = ({ signal }) => getDeliverObjectReleaseIdRelease(releaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!releaseId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectReleaseIdReleaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
>;
export type GetDeliverObjectReleaseIdReleaseInfiniteQueryError = void;

export function useGetDeliverObjectReleaseIdReleaseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  >,
  TError = void,
>(
  releaseId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectReleaseIdReleaseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  >,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectReleaseIdReleaseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  >,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Release Id
 */

export function useGetDeliverObjectReleaseIdReleaseInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  >,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectReleaseIdReleaseInfiniteQueryOptions(
    releaseId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectReleaseIdReleaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectReleaseIdReleaseQueryKey(releaseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
  > = ({ signal }) => getDeliverObjectReleaseIdRelease(releaseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!releaseId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectReleaseIdReleaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
>;
export type GetDeliverObjectReleaseIdReleaseQueryError = void;

export function useGetDeliverObjectReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Release Id
 */

export function useGetDeliverObjectReleaseIdRelease<
  TData = Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
  TError = void,
>(
  releaseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectReleaseIdRelease>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectReleaseIdReleaseQueryOptions(
    releaseId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
